import { genAxiosClient } from "@smartsheet/http-client";
// export a standard axios client instance that we can spy on in tests
// this should never be exported on the index.
export var client = genAxiosClient();
export var XSRF_HEADER = "x-smar-xsrf";
export function buildSynchronousSettingsRequest(url) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, false);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("x-smar-trace-id", generateTraceId());
    xhr.setRequestHeader(XSRF_HEADER, getSessionKey());
    var sessionID = getSessionID();
    if (sessionID) {
        xhr.setRequestHeader("Smartsheet-sid", sessionID);
    }
    return xhr;
}
export var generateTraceId = function () {
    return randomStringOfLength(16) + "-" + Date.now();
};
var randomStringOfLength = function (length) {
    var result = "";
    var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var CHARSET_LENGTH = CHARSET.length;
    var counter = 0;
    while (counter < length) {
        result += CHARSET.charAt(Math.floor(Math.random() * CHARSET_LENGTH));
        counter += 1;
    }
    return result;
};
export var unsafeWindowObjectRetrieve = function (property) {
    var prop = window[property];
    if (!prop) {
        throw new Error("Failed to find " + property + " on the window!");
    }
    return prop;
};
export var getSessionID = function () {
    var _a;
    var clientState = unsafeWindowObjectRetrieve("clientState");
    return (_a = clientState.sessionID) !== null && _a !== void 0 ? _a : undefined;
};
export var getSessionKey = function () {
    var clientState = unsafeWindowObjectRetrieve("clientState");
    return clientState.sessionKey;
};
//# sourceMappingURL=http.js.map